import { AIAssistantReviewSurvey, ApplicantIdentities, ApplicantPortalPage, Block, Collection, CustomBarChart, CustomNumber, CustomPieChart, Dashboard, DashboardComponent, ExpandedSurvey, GiveCardMailing, Macro, NotificationGroup, Payment, Subsurvey, Table, TopLevelTemplatedBlock, USBankCardMailing, UsioMailing } from "@aidkitorg/types/lib/survey";
import { expandTemplates } from "@aidkitorg/types/lib/translation/v0_to_legacy";

export type SearchableComponent =
  Block
  | Collection
  | NotificationGroup
  | TopLevelTemplatedBlock
  | Payment
  | Dashboard
  | DashboardComponent
  | UsioMailing
  | GiveCardMailing
  | USBankCardMailing
  | ApplicantIdentities
  | Macro
  | ApplicantPortalPage
  | Table
  | CustomNumber
  | CustomBarChart
  | CustomPieChart
  | AIAssistantReviewSurvey;

export default function enumerateSubsurveys(survey: ExpandedSurvey['survey']) {
  if (survey) {
    survey = expandTemplates(survey) as ExpandedSurvey['survey'];
  }

  function traverse(block: SearchableComponent): Subsurvey[] {
    if (block.kind == 'Subsurvey') {
      return [block, ...block.sections.flatMap(traverse)];
    }
    if (block.kind == 'Section') {
      return block.components.flatMap(traverse);
    }
    if (block.kind == 'Collection') {
      return block.components.flatMap(traverse);
    }
    return [];
  }
  const subsurveys = (survey || []).flatMap(traverse);
  return subsurveys;
}